import React, { Component } from 'react';

import "./Israelies.scss"

import data from "../../api/data.json"
import pngClock from "../../static/images/clock.png"

class Israelies extends Component {
  constructor() {
    super();
    this.state = {
      clockIcon: {
        backgroundImage: "url(" + pngClock + ")"
      }
    }
  }
  render() {
    return (
      <section className="section section-israelies">
        <div className="padding">
          <div className="infograph">
            <div className="unique-icon">
              <div className="unique">
                <div className="box">
                  {data.analytics.howmany.num}
                </div>
                <div className="unique-desc">
                  <div className="desc" dangerouslySetInnerHTML={{ __html: data.analytics.howmany.afterText2 }}></div>
                </div>
              </div>
            </div>
            <div className="clock-icon">
              <div className="clock" style={this.state.clockIcon}>
                <div className="box red">
                  <div className="countertext">
                    {data.analytics.time.time}
                  </div>
                </div>
              </div>
              <div className="clock-desc">
                <div className="desc" dangerouslySetInnerHTML={{ __html: data.analytics.time.desc }}></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Israelies;



// WEBPACK FOOTER //
// ./src/components/Israelies/Israelies.js